<ng-container *ngFor="let feature of features">
  <ng-container [framingComponentOutlet]="feature.controller" [framingComponentName]="feature.name" (onComponent)="onController($event, feature)" (onError)="onController($event, feature)"></ng-container>
</ng-container>
